import { format } from "date-fns";
import { enUS, es, ptBR } from "date-fns/locale";

export const translationPath = "page.4uBus.logs.calendarControl.";

export const CALENDAR_CONTROL_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/CalendarControlXl/CalendarControlXl";

export const CALENDAR_CONTROL_ITEM_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/CalendarControlItemXl/CalendarControlItemXl";

// CONSULTA/RETORNO/CHECKUP vêm do enum ConsultationType (fluxo de consulta);
// EXAME é gravado fixo pelo fluxo de exame.
export const TYPE_OF_APPOINTMENT_VALUES = [
  "CONSULTA",
  "RETORNO",
  "CHECKUP",
  "EXAME",
] as const;

// Status conhecidos do cabeçalho (CALENDARCONTROL_XL.STATUS). Outros valores são exibidos como texto.
export const LIST_STATUS_VALUES = [
  "LISTA EM CRIACAO",
  "LISTA CRIADA",
  "LISTA FINALIZADA",
] as const;

export const ITEM_STATUS_VALUES = ["PENDENTE", "PROCESSADO"] as const;

type TChipColor = "default" | "info" | "warning" | "success" | "error";

export const listStatusConfig: Record<string, { color: TChipColor; key: string }> =
  {
    "LISTA EM CRIACAO": { color: "info", key: "LISTA EM CRIACAO" },
    "LISTA CRIADA": { color: "warning", key: "LISTA CRIADA" },
    "LISTA FINALIZADA": { color: "success", key: "LISTA FINALIZADA" },
  };

export const itemStatusConfig: Record<string, { color: TChipColor; key: string }> =
  {
    PENDENTE: { color: "warning", key: "PENDENTE" },
    PROCESSADO: { color: "success", key: "PROCESSADO" },
  };

const dateFnsLocale = (language: string) =>
  language === "pt-BR" ? ptBR : language === "en-US" ? enUS : es;

export const formatDateTime = (value: string | null | undefined, language: string) => {
  if (!value) return "-";

  const date = new Date(value);
  if (isNaN(date.getTime())) return "-";

  return format(date, "Pp", { locale: dateFnsLocale(language) }).replaceAll(",", "");
};

export const formatDate = (value: string | null | undefined, language: string) => {
  if (!value) return "-";

  const date = new Date(value);
  if (isNaN(date.getTime())) return "-";

  return format(date, "P", { locale: dateFnsLocale(language) });
};

export const formatDocument = (value: string | null | undefined) => {
  if (!value) return "-";
  const digits = value.replace(/\D/g, "");
  if (digits.length !== 11) return value;
  return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
};

/** Formata um JSON armazenado como texto; se não for JSON válido, devolve o texto original. */
export const prettyJson = (value: string | null | undefined) => {
  if (!value) return "";
  try {
    return JSON.stringify(JSON.parse(value), null, 2);
  } catch {
    return value;
  }
};

/** Converte uma Date do filtro para "yyyy-MM-dd" ignorando fuso (mesmo padrão das outras telas de log). */
export const toDateParam = (date: Date | null) =>
  date
    ? new Date(new Date(date).setHours(15)).toISOString().substring(0, 10)
    : undefined;
